const SITE_URL = 'https://nikketengg.com';
const SITE_NAME = 'Nikket Engineering Works';
const PHONE = '+919876543210';

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": SITE_NAME,
  "url": SITE_URL,
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": PHONE,
    "contactType": "customer service",
    "areaServed": "IN",
    "availableLanguage": ["English", "Hindi", "Gujarati"]
  }
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": SITE_NAME,
  "url": SITE_URL,
  "publisher": {
    "@type": "Organization",
    "name": SITE_NAME
  }
};

export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": SITE_NAME,
  "url": SITE_URL,
  "telephone": PHONE,
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Ahmedabad",
    "addressRegion": "Gujarat",
    "addressCountry": "IN"
  },
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    "opens": "09:00",
    "closes": "18:00"
  },
  "priceRange": "$$",
  "description": "Expert HVAC design, installation, and maintenance services for commercial and industrial projects in Ahmedabad, Gujarat."
};

export const serviceSchemas = [
  {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "HVAC System Design",
    "description": "Professional HVAC system design for commercial and industrial buildings, ensuring optimal air flow, energy efficiency, and comfort.",
    "provider": { "@type": "Organization", "name": SITE_NAME, "url": SITE_URL },
    "areaServed": "India"
  },
  {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "HVAC Installation",
    "description": "Complete HVAC installation services including air conditioning, heating, and ventilation systems for new and existing buildings.",
    "provider": { "@type": "Organization", "name": SITE_NAME, "url": SITE_URL },
    "areaServed": "India"
  },
  {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "HVAC Maintenance & Repair",
    "description": "Regular maintenance and emergency repair services for all types of HVAC systems to ensure peak performance and longevity.",
    "provider": { "@type": "Organization", "name": SITE_NAME, "url": SITE_URL },
    "areaServed": "India"
  }
];

export const faqPageSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What HVAC services does Nikket Engineering Works offer?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We offer comprehensive HVAC services including system design, installation, maintenance, and repair for commercial and industrial clients."
      }
    },
    {
      "@type": "Question",
      "name": "Where is Nikket Engineering Works located?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We are based in Ahmedabad, Gujarat, India, and serve clients across the region."
      }
    },
    {
      "@type": "Question",
      "name": "How often should HVAC systems be serviced?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We recommend servicing your HVAC system at least twice a year — before summer and winter — to ensure optimal performance and energy efficiency."
      }
    },
    {
      "@type": "Question",
      "name": "Do you provide emergency HVAC repair services?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we provide prompt emergency repair services for all types of HVAC systems. Contact us for immediate assistance."
      }
    },
    {
      "@type": "Question",
      "name": "Can you design HVAC systems for large commercial buildings?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely. We specialize in HVAC design for commercial and industrial buildings of all sizes, ensuring energy efficiency and comfort."
      }
    }
  ]
};

export function breadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      ...(item.url ? { "item": item.url } : {})
    }))
  };
}
